import { DOWNLOAD_FILES_QUERY } from './download-files.query';
import { graphql } from '../gql';
import { useMutation } from '@apollo/client';

const CREATE_BINDER_LETTER_MUTATION = graphql(`
  mutation createBinderLetter($submissionUuid: String!) {
    createBinderLetter(submissionUuid: $submissionUuid) {
      result
      savedDocuments
      folder
    }
  }
`);

export function useCreateBinderLetterMutation() {
  const [createBinderLetter, { data, loading, error, reset }] = useMutation(
    CREATE_BINDER_LETTER_MUTATION,
    {
      refetchQueries: [DOWNLOAD_FILES_QUERY],
      awaitRefetchQueries: true,
    }
  );

  return {
    data,
    createBinderLetter,
    loading,
    error,
    reset,
  };
}
